'use strict';

var _get = require('babel-runtime/helpers/get')['default'];

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _createClass = require('babel-runtime/helpers/create-class')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _defineProperty = require('babel-runtime/helpers/define-property')['default'];

var _extends = require('babel-runtime/helpers/extends')['default'];

var _objectWithoutProperties = require('babel-runtime/helpers/object-without-properties')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _utils = require('./utils');

var Grid = (function (_React$Component) {
  _inherits(Grid, _React$Component);

  function Grid() {
    _classCallCheck(this, Grid);

    _get(Object.getPrototypeOf(Grid.prototype), 'constructor', this).apply(this, arguments);
  }

  _createClass(Grid, [{
    key: 'render',
    value: function render() {
      var _bem;

      var _props = this.props;
      var children = _props.children;
      var componentClass = _props.componentClass;
      var _props$wrap = _props.wrap;
      var wrap = _props$wrap === undefined ? true : _props$wrap;
      var verticalAlign = _props.verticalAlign;
      var noGutter = _props.noGutter;
      var className = _props.className;

      var props = _objectWithoutProperties(_props, ['children', 'componentClass', 'wrap', 'verticalAlign', 'noGutter', 'className']);

      var classNames = (0, _utils.bem)("o-grid", (_bem = {
        wrap: wrap
      }, _defineProperty(_bem, verticalAlign, true), _defineProperty(_bem, "no-gutter", noGutter), _bem), className);

      var Component = componentClass || 'div';

      return _react2['default'].createElement(
        Component,
        _extends({}, props, { className: classNames }),
        children
      );
    }
  }]);

  return Grid;
})(_react2['default'].Component);

exports.Grid = Grid;

var Cell = (function (_React$Component2) {
  _inherits(Cell, _React$Component2);

  function Cell() {
    _classCallCheck(this, Cell);

    _get(Object.getPrototypeOf(Cell.prototype), 'constructor', this).apply(this, arguments);
  }

  _createClass(Cell, [{
    key: 'render',
    value: function render() {
      var _bem2;

      var _props2 = this.props;
      var children = _props2.children;
      var componentClass = _props2.componentClass;
      var width = _props2.width;
      var fixedWidth = _props2.fixedWidth;
      var offset = _props2.offset;
      var verticalAlign = _props2.verticalAlign;
      var noGutter = _props2.noGutter;
      var className = _props2.className;
      var _props2$style = _props2.style;
      var style = _props2$style === undefined ? {} : _props2$style;

      var props = _objectWithoutProperties(_props2, ['children', 'componentClass', 'width', 'fixedWidth', 'offset', 'verticalAlign', 'noGutter', 'className', 'style']);

      var classNames = (0, _utils.bem)("o-grid__cell", (_bem2 = {}, _defineProperty(_bem2, verticalAlign, true), _defineProperty(_bem2, width && "width-" + width, true), _defineProperty(_bem2, offset && "offset-" + offset, true), _defineProperty(_bem2, "no-gutter", noGutter), _defineProperty(_bem2, "width-fixed", fixedWidth), _bem2));
      // Check sizes
      _utils.sizes.forEach(function (size) {
        var w = props[size + "Width"];
        if (w) {
          classNames += ' o-grid__cell--width-' + w + '@' + size;
          delete props[size + "Width"];
        }
        var o = props[size + "Offset"];
        if (o) {
          classNames += ' o-grid__cell--offset-' + o + '@' + size;
          delete props[size + "Offset"];
        }
      });
      _utils.sizeAlias.forEach(function (size, idx) {
        var w = props[size];
        if (w) {
          classNames += ' o-grid__cell--width-' + w + '@' + _utils.sizes[idx];
          delete props[size];
        }
        var o = props[size + "Offset"];
        if (o) {
          classNames += ' o-grid__cell--offset-' + o + '@' + _utils.sizes[idx];
          delete props[size + "Offset"];
        }
      });
      if (className) classNames += " " + className;

      var finalStyle = style;
      if (fixedWidth) {
        finalStyle = _extends({}, style, {
          width: fixedWidth
        });
      }

      var Component = componentClass || 'div';

      return _react2['default'].createElement(
        Component,
        _extends({}, props, { style: finalStyle, className: classNames }),
        children
      );
    }
  }]);

  return Cell;
})(_react2['default'].Component);

exports.Cell = Cell;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-blazecss/lib/Grid.js
 ** module id = 453
 ** module chunks = 0
 **/